module.exports = __webpack_public_path__ + "img/x1.341f9026.jpg";